import { TicketCategory, TicketCategoryID, TicketSubCategory } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchTicketCategoryTypes() {
  const source = axios.CancelToken.source();
  const [fetching, setFetching] = useState(false);
  const [ticketCategories, setTicketCategories] = useState<TicketCategory[]>([
    {
      ID: TicketCategoryID.GENERAL_INQUIRY,
      Category: 'General inquiry',
    },
  ]);

  const [ticketSubCategories, setTicketSubCategories] = useState<TicketSubCategory[]>([
    {
      SupportTicketCatagories_ID: TicketCategoryID.GENERAL_INQUIRY,
      SubCategory: 'General inquiry',
    },
  ]);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function fetchTicketCategoryTypes() {
    try {
      setFetching(true);
      const res = await api.fetchClientDashboardTicketCategories(source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setTicketCategories(res.SupportTicketCategory);
      setTicketSubCategories(res.SupportTicketSubCategory);

      return res;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    ticketCategories,
    ticketSubCategories,
    fetchTicketCategoryTypes,
  };
}
